import * as React from 'react'

import * as styles from './privacyNoticeBanner.module.css'

const PrivacyNoticeBanner = () => (
  <div className={styles.root}>
    <p className={styles.text}>
      Your browser appears to block all cookies. This site requires some cookies
      to function correctly. Please review your brower settings before
      continuing.
    </p>
  </div>
)

export default PrivacyNoticeBanner
